import styles from './MaestroMark.module.css';

// The Maestro's brand mark — a 1:1 port of native's `MaestroBrandMark` (iOS
// `MaestroBrandMark.swift`, Android `MaestroMark`): a dark rounded tile carrying a
// 2×2 grid whose leading diagonal is rounded squares and whose other diagonal is
// circles. Wherever the team lead is shown as itself (the genome centre, the agent
// pile, the Maestro page's hero) it wears THIS, not the Symphony brand mark.
//
// It is deliberately NOT an `AgentDot` and never goes through the agent colour
// system — the team lead's mark is reserved (see common-lib `agentColor.ts`).
//
// The reference viewBox is 52, native's authoring size, so every measure below is
// that grid and the mark scales by the viewBox alone.

const BOX = 52;
const TILE_RADIUS = 16;
const SHAPE = 11.2858;
const GAP = 3.76;
const PITCH = SHAPE + GAP;
const SQUARE_RADIUS = 4;

const CENTER = BOX / 2;
const NEAR = CENTER - PITCH / 2 - SHAPE / 2;
const FAR = CENTER + PITCH / 2 - SHAPE / 2;

export function MaestroMark({ className, size }: { className?: string; size?: number }) {
  return (
    <svg className={className} width={size} height={size} viewBox={`0 0 ${BOX} ${BOX}`} aria-hidden focusable="false">
      <rect width={BOX} height={BOX} rx={TILE_RADIUS} className={styles.tile} />
      <rect x={NEAR} y={NEAR} width={SHAPE} height={SHAPE} rx={SQUARE_RADIUS} className={styles.shape} />
      <rect x={FAR} y={FAR} width={SHAPE} height={SHAPE} rx={SQUARE_RADIUS} className={styles.shape} />
      <circle cx={FAR + SHAPE / 2} cy={NEAR + SHAPE / 2} r={SHAPE / 2} className={styles.shape} />
      <circle cx={NEAR + SHAPE / 2} cy={FAR + SHAPE / 2} r={SHAPE / 2} className={styles.shape} />
    </svg>
  );
}
